/**
 * アプリ固有例外クラス
 *
 * 予期しているシステムエラーはこのクラスで例外をthrowする
 */
export default class SystemError extends Error {
  /** コード */
  code?: string;
  /** ステータスコード */
  statusCode?: number;
  /** メソッド */
  method?: string;
  /** エラーメッセージ */
  errorMessage: string;
  /** オリジナルメッセージ */
  originalResponse: any;
  /** エラースタック */
  stackTrace?: string;
  /** ヘッダー */
  headers?: any;
  /** リクエスト */
  request?: any;
  /** ステータステキスト */
  statusText?: string;
  /** 画面URL */
  url?: string;
  /** Vue固有の付加情報、存在しない場合がある */
  info?: any;
  /** API URL */
  apiUrl?: string;
  /** リクエストボディ */
  requestBody?: any;
  /** 画面アプリとしてのエラー種別 */
  hitomeqErrorType?: HitomeqErrorType;

  /**
   * コンストラクターで親クラスのsuperを実行する。
   *
   * @param message エラーメッセージ
   */
  constructor(message: string) {
    super(message);
    this.errorMessage = message;
  }
}

export enum HitomeqErrorType {
  /** システムエラー対象 */
  SYSTEM_ERROR = 0,
  /** ユーザーへリトライ要求対象 */
  REQUEST_RETRY = 1,
  /** 無視の対象 */
  IGNORE = 2
}
